<div class="stepper">
  <div class="stepper-title">{{ title | translate }}</div>

  <div class="stepper-progress-bar-wrapper">
    <div class="stepper-progress-bar-line" [style.width.%]="barWidth"></div>
  </div>

  <div class="stepper-content">
    <ng-template
      [dynamic-component]="componentRef"
      [inputs]="componentInputs"
      [outputs]="componentOutputs"
      [stepIndex]="currentWizardIndex"
      (componentCreated)="setInnerComponentRef($event)"
    ></ng-template>
  </div>

  <div class="stepper-footer">
    <button type="button" class="stepper-footer-back" (click)="back()">
      {{ backTitle | translate }}
    </button>

    <button type="button" class="stepper-footer-next" (click)="next()">
      <span class="stepper-footer-next-wrapper">
        {{ nextTitle | translate }}

        <img class="stepper-footer-next-icon" src="assets/icons/icon_arrow_right_white.svg" />
      </span>
    </button>
  </div>
</div>
